import { useEffect, useCallback } from 'react';
import { createColumnSelectionEvent } from '../events';
export var useTableEvents = function (_a) {
    var chartEvents = _a.chartEvents, onDeselectColumns = _a.onDeselectColumns;
    useEffect(function () {
        var unsubscribe = null;
        if (chartEvents) {
            unsubscribe = chartEvents.subscribe(function (_a) {
                var eventName = _a.eventName;
                switch (eventName) {
                    case '@table/deselect-columns':
                        onDeselectColumns();
                }
            });
        }
        return function () {
            unsubscribe && unsubscribe();
        };
    }, [chartEvents]);
    var publishColumnSelection = useCallback(function (data, formatters, selectedColumns) {
        if (chartEvents) {
            var eventPayload = createColumnSelectionEvent({
                data: data,
                selectedColumns: selectedColumns,
                formatters: formatters,
            });
            chartEvents.publish(eventPayload);
        }
    }, [chartEvents]);
    return {
        publishColumnSelection: publishColumnSelection,
    };
};
